<template>
  <div class="max-w-[2560px] mx-auto">
    <div>
      <navigation-bar :hasNoBg="true"></navigation-bar>
    </div>

    <div>
      <router-view></router-view>
    </div>

    <div>
      <contact-us-component></contact-us-component>
    </div>

    <div>
      <footer-view></footer-view>
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/view/NavigationBar.vue";
import footerView from "@/view/footerView.vue";
import contactUsComponent from "./contactUsComponent.vue";
export default {
  components: {
    NavigationBar,
    footerView,
    contactUsComponent,
  },
  data() {
    return {};
  },
};
</script>

<style></style>
